export default "__VITE_ASSET__8143316c__"